export const DEFAULT_COLORS = {
  primary: 'steelblue',
};
